"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApi;

var _wretch = _interopRequireDefault(require("wretch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createApi(url, options = {}) {
  return (0, _wretch.default)(url).middlewares([next => async (url, options) => {
    const body = JSON.stringify(_objectSpread({
      jsonrpc: '2.0',
      id: 1,
      params: []
    }, JSON.parse(options.body)));
    return next(url, _objectSpread({}, options, {
      body
    }));
  }]).resolve(async res => {
    const {
      result,
      error
    } = await res.json();

    if (error) {
      throw new Error(JSON.stringify(error));
    }

    return result;
  });
}